import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode } from "vue"
import _imports_0 from '@/assets/bioa_logo.png'


const _hoisted_1 = { class: "app-topbar" }
const _hoisted_2 = { class: "app-topbar__search" }
const _hoisted_3 = {
  key: 0,
  class: "app-topbar__results"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  class: "app-topbar__quick",
  "aria-label": "빠른이동 메뉴"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  class: "quick-icon",
  "aria-hidden": "true"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "app-content" }

import { computed, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import menuIcon from '@/assets/quick-icons/quick-menu.svg';
import deskIcon from '@/assets/quick-icons/quick-desk.svg';
import calendarIcon from '@/assets/quick-icons/quick-calendar.svg';
import consultIcon from '@/assets/quick-icons/quick-consult.svg';
import photoIcon from '@/assets/quick-icons/quick-photo.svg';
import documentIcon from '@/assets/quick-icons/quick-document.svg';
import ediIcon from '@/assets/quick-icons/quick-edi.svg';
import statsIcon from '@/assets/quick-icons/quick-stats.svg';
import logoutIcon from '@/assets/quick-icons/quick-logout.svg';

type MenuLink = {
  title: string;
  group: string;
  path: string;
  keywords: string[];
};

type QuickMenu = {
  title: string;
  icon: string;
  path: string;
  action?: 'logout';
};


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();
const router = useRouter();
const globalSearch = ref('');
const searchFocused = ref(false);

const menus: MenuLink[] = [
  { title: '전체 메뉴', group: '메인', path: '/menu', keywords: ['메뉴', 'main'] },
  { title: '데스크', group: '데스크', path: '/desk', keywords: ['접수', '수납', '예약목록'] },
  { title: '사용자 권한관리', group: '환경설정', path: '/users-permissions', keywords: ['사용자', '권한', '계정'] },
  { title: '환자관리', group: '환자', path: '/patients', keywords: ['환자', '고객', '차트'] },
  { title: '고객관리', group: 'CRM', path: '/client-manage', keywords: ['고객', 'CRM', '리콜'] },
  { title: '예약', group: '예약', path: '/reservation', keywords: ['예약', '내원'] },
  { title: '캘린더', group: '예약', path: '/calendar', keywords: ['달력', '예약', '일정'] },
  { title: '접수', group: '데스크', path: '/reception', keywords: ['접수', '대기', '내원'] },
  { title: 'EMR', group: '진료', path: '/emr', keywords: ['전자차트', '진료', '차트'] },
  { title: '수납/결제', group: '수납', path: '/payments', keywords: ['결제', '수납', '미수금'] },
  { title: '보험청구', group: '보험', path: '/insurance-claims', keywords: ['보험', '청구', 'EDI'] },
  { title: '문서/증명서', group: '문서', path: '/documents', keywords: ['문서', '증명서', '영수증'] },
  { title: '상담 보드', group: '상담', path: '/counseling', keywords: ['상담', '사진'] },
  { title: '가격 책정', group: '경영', path: '/price', keywords: ['가격', '수가', '비용'] },
  { title: '통계', group: '경영', path: '/analytics', keywords: ['통계', '매출', '실적'] },
  { title: '알림/리콜', group: 'CRM', path: '/alerts', keywords: ['알림', '문자', '리콜', '메신저'] },
  { title: '코드마스터', group: '환경설정', path: '/codes', keywords: ['설정', '코드', '환경'] },
];

const quickMenus: QuickMenu[] = [
  { title: '전체 메뉴', icon: menuIcon, path: '/menu' },
  { title: '데스크', icon: deskIcon, path: '/desk' },
  { title: '예약', icon: calendarIcon, path: '/calendar' },
  { title: '환자 상담', icon: consultIcon, path: '/plan' },
  { title: '사진 보기', icon: photoIcon, path: '/monitor' },
  { title: '문서 발급', icon: documentIcon, path: '/documents' },
  { title: '청구/EDI', icon: ediIcon, path: '/insurance-claims' },
  { title: '경영/통계', icon: statsIcon, path: '/analytics' },
  { title: '로그아웃', icon: logoutIcon, path: '/login', action: 'logout' },
];

const isAuthPage = computed(() => route.path === '/login' || route.path === '/master');
const isMobilePage = computed(() => route.path === '/m' || route.path.startsWith('/m/'));
const isStandalonePage = computed(() => isAuthPage.value || isMobilePage.value);
const filteredMenus = computed(() => {
  const query = globalSearch.value.trim().toLowerCase();
  if (!query) return [];
  return menus
    .filter((menu) => [menu.title, menu.group, ...menu.keywords].join(' ').toLowerCase().includes(query))
    .slice(0, 8);
});

function goMenu() {
  router.push('/menu');
}

function goFirstResult() {
  const first = filteredMenus.value[0];
  if (first) goPage(first.path);
}

function goPage(path: string) {
  globalSearch.value = '';
  searchFocused.value = false;
  router.push(path);
}

function logout() {
  localStorage.removeItem('bioa-session');
  router.push('/login');
}

return (_ctx: any,_cache: any) => {
  const _component_RouterView = _resolveComponent("RouterView")!

  return (_openBlock(), _createElementBlock("main", {
    class: _normalizeClass(['app-root', { 'app-root--auth': isStandalonePage.value }])
  }, [
    (isStandalonePage.value)
      ? (_openBlock(), _createBlock(_component_RouterView, { key: 0 }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("header", _hoisted_1, [
            _createElementVNode("button", {
              class: "app-topbar__brand",
              type: "button",
              onClick: goMenu
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("img", {
                src: _imports_0,
                alt: "BIOA"
              }, null, -1)
            ])),
            _createElementVNode("div", _hoisted_2, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((globalSearch).value = $event)),
                type: "text",
                placeholder: "메뉴 검색",
                onFocus: _cache[1] || (_cache[1] = ($event: any) => (searchFocused.value = true)),
                onKeyup: _withKeys(goFirstResult, ["enter"])
              }, null, 544), [
                [_vModelText, globalSearch.value]
              ]),
              _createElementVNode("button", {
                type: "button",
                onClick: goFirstResult
              }, "검색"),
              (searchFocused.value && globalSearch.value && filteredMenus.value.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredMenus.value, (menu) => {
                      return (_openBlock(), _createElementBlock("button", {
                        key: menu.path,
                        type: "button",
                        onClick: ($event: any) => (goPage(menu.path))
                      }, [
                        _createElementVNode("strong", null, _toDisplayString(menu.title), 1),
                        _createElementVNode("span", null, _toDisplayString(menu.group), 1)
                      ], 8, _hoisted_4))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("nav", _hoisted_5, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(quickMenus, (item) => {
                return _createElementVNode("button", {
                  key: item.title,
                  type: "button",
                  class: _normalizeClass({ active: item.path && _unref(route).path === item.path }),
                  onClick: ($event: any) => (item.action === 'logout' ? logout() : goPage(item.path))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createElementVNode("img", {
                      src: item.icon,
                      alt: ""
                    }, null, 8, _hoisted_8)
                  ]),
                  _createElementVNode("strong", null, _toDisplayString(item.title), 1)
                ], 10, _hoisted_6)
              }), 64))
            ])
          ]),
          _createElementVNode("section", _hoisted_9, [
            _createVNode(_component_RouterView)
          ])
        ], 64))
  ], 2))
}
}

})